<label class="field-label">{{ label }}</label>
<cc-form-field-settings-indicators [fieldSettings]="model" />
<ng-content />
